import { FontSize } from '@icon-park/vue-next';
import { message } from 'ant-design-vue';
import { state } from './../store/state';
import { computed, ref} from 'vue'
import { MutationTypes, useStore } from '@/store'
import { pasteCustomClipboardString } from '@/utils/clipboard'
import { PPTElement, Slide } from '@/types/slides'
import { createRandomCode } from '@/utils/common'
import { createElementIdMap } from '@/utils/element'
import { parseText2Paragraphs } from '@/utils/textParser'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useCreateElement from '@/hooks/useCreateElement'
import { UploadService } from '@/api/upload'

interface PasteTextClipboardDataOptions {
  onlySlide?: boolean;
  onlyElements?: boolean;
}

export default () => {
  const store = useStore()
  const currentSlide = computed<Slide>(() => store.getters.currentSlide)
  let num = 0
  const { addHistorySnapshot } = useHistorySnapshot()  
  const { createTextElement } = useCreateElement()
  const { createImageElement } = useCreateElement()
  /**
   * 粘贴元素（一组）
   * @param elements 元素列表数据
   */
  const addElementsFromClipboard = (elements: PPTElement[]) => {
    num++
    const { groupIdMap, elIdMap } = createElementIdMap(elements)
    const currentSlideElementIdList = currentSlide.value.elements.map(el => el.id)
    for (const element of elements) {
      const inCurrentSlide = currentSlideElementIdList.includes(element.id)
      
      element.id = elIdMap[element.id]

      if (inCurrentSlide) {
        element.left = element.left + 20 * num
        element.top = element.top + 20 * num
      }

      if (element.groupId) element.groupId = groupIdMap[element.groupId]
    }
    LOAD_FONTS(elements,'ele')
    store.commit(MutationTypes.ADD_ELEMENT, elements)
    store.commit(MutationTypes.SET_ACTIVE_ELEMENT_ID_LIST, Object.values(elIdMap))
    addHistorySnapshot()
     
  }

  /**
   * 粘贴页面
   * @param slide 页面数据
   */
  const addSlidesFromClipboard = (slides: Slide[]) => {
    const newSlides = slides.map(slide => {
      const { groupIdMap, elIdMap } = createElementIdMap(slide.elements)

      for (const element of slide.elements) {
        element.id = elIdMap[element.id]
        if (element.groupId) element.groupId = groupIdMap[element.groupId]
      }
      if (slide.animations) {
        for (const animation of slide.animations) {
          animation.elId = elIdMap[animation.elId]
        }
      }
      return {
        ...slide,
        id: createRandomCode(8),
      }
    })
    LOAD_FONTS(newSlides,'slide')
    store.commit(MutationTypes.ADD_SLIDE, newSlides)
    addHistorySnapshot()
     
  }

  /**
   * 粘贴普通文本：创建为新的文本元素
   * @param text 文本
   */
  const createTextElementFromClipboard = (text: string) => {
 
    createTextElement({
      left: 0,
      top: 0,
      width: 600,
      height: 50
    }, text)
  }

  /**
   * 解析剪贴板内容，根据解析结果选择合适的粘贴方式
   * @param text 剪贴板内容
   * @param options 配置项：onlySlide -- 仅处理页面粘贴；onlyElements -- 仅处理元素粘贴；
   */
  // 偏移量
  // let width = 0
  // let topnum = 20 
  const pasteTextClipboardData = (text: string, options?: PasteTextClipboardDataOptions) => {
    const onlySlide = options?.onlySlide || false
    const onlyElements = options?.onlyElements || false
    const clipboardData = pasteCustomClipboardString(text)
    const isCopy = computed(() => store.state.isElementCopy)
    if (isCopy.value) {
      num = 0
    }
    // 元素或页面
    if (typeof clipboardData === 'object') {
      const { type, data } = clipboardData

      if (type === 'elements' && !onlySlide) {
        let isCopy = true
        data.forEach((item:any) => {
          if (item.isPay) {
            isCopy = false
          }
        })
        if (isCopy) {
          addElementsFromClipboard(data)
        }
        else {
          message.error('收费模板的元素不支持跨模板粘贴')
        }
      }
      else if (type === 'slides' && !onlyElements){
        let isCopy = true
        data.forEach((item:any) => {
          if (item.isPay) {
            isCopy = false
          }
        })
        if (isCopy) {
          addSlidesFromClipboard(data)
        }
        else {
          message.error('收费模板的元素不支持跨模板粘贴')
        }
      } 
      
     
    }

    // 普通文本
    else if (!onlyElements && !onlySlide) {
      if (clipboardData.indexOf("data:image/webp") !== -1 || clipboardData.indexOf("data:image/svg+xml") !== -1 || clipboardData.indexOf("data:image/png") !== -1 || clipboardData.indexOf("data:image/jpeg") !== -1) {
        uploadBase64(clipboardData)
        return
      }
      const string = parseText2Paragraphs(clipboardData)
      const _text = `<p style="text-align: left;"><span style="color: rgb(51, 51, 51);"><span style="font-size: 14px">${string.replace(/<.*?>/g,"")}</span></span></p>`
 
      createTextElementFromClipboard(_text)
    }
    store.commit(MutationTypes.SET_COPY_STATE, false)
  }
  const uploadBase64 = async (clipboardData:any) => {
    const params = {
      height:'',
      width:'',
      type: '',
      base64Data:clipboardData
    }

    const res = await UploadService.base64image(params)
    if (res.data.state === '2' || res.data.state === 2) {
      createImageElement(String(res.data.result))
    }
    else {
      message.error(res.data.message)
    }

  }
  const fontsList = computed(() => store.state.slidesFontsList);
  const currFont = ref([]);
  const currFontOld = ref([]);
  const sildeFonts = computed(() => store.state.slideFonts);
  const getFonts = () => {
    sildeFonts.value.map((k: any) => {
      fontsList.value.map((f: any) => {
        if (k === f.enName) {
          currFont.value.push(f as never);
        }
        if (k === f.name) {
          currFontOld.value.push(f as never);
        }
      });
    });
    document.getElementById("font-f")?.remove();
    const style = document.createElement("style");
    style.id = "font-f";
    style.type = "text/css";
    currFont.value.forEach((f: any) => {
      style.innerText +=
        "@font-face {font-family:'" + f.enName + "';src:url('" + f.filePath + "')}";
    });
    currFontOld.value.forEach((f: any) => {
      style.innerText +=
        "@font-face {font-family:'" + f.name + "';src:url('" + f.filePath + "')}";
    });
    document.getElementsByTagName("head")[0].appendChild(style);
    store.commit(
      MutationTypes.SET_SLIDES_USE_FONTS_LIST,
      new Set(currFont.value.concat(currFontOld.value))
    );
  };
  const LOAD_FONTS = (data: any,type:any) => {
    let fontArr: any[] = [];
    const fonts:any[] = [];
    let isRe = false
    if (type === 'ele') {
      data.forEach((ele: any) => {
        if (ele.type === "text") {
          fontArr.push(
            String(
              ...new Set(
                ele.content && ele.content.match(/(font-family:[^><;"]*(;)?)/gi)
              )
            )
          );
          if (ele.defaultFontName) {
            fontArr.push("font-family: " + ele.defaultFontName);
          }
        } else if (ele.type === "rect") {
          fontArr.push(
            String(
              ...new Set(
                ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
              )
            )
          );
        } else if (ele.type === "shape") {
          fontArr.push(
            String(
              ...new Set(
                ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
              )
            )
          );
        }
      });
   
    }
    else {
      data.forEach((item: any) => {
        item.elements.forEach((ele: any) => {
          if (ele.type === "text") {
            fontArr.push(
              String(
                ...new Set(
                  ele.content && ele.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
            if (ele.defaultFontName) {
              fontArr.push("font-family: " + ele.defaultFontName);
            }
          } else if (ele.type === "rect") {
            fontArr.push(
              String(
                ...new Set(
                  ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
          } else if (ele.type === "shape") {
            fontArr.push(
              String(
                ...new Set(
                  ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
          }
        });
      });
    }


    fontArr = [...new Set(fontArr)];
    
    if (fontArr.length > 0) {
      fontArr.forEach((item) => {
        if (item !== "") {
          const f = String(item);
          fonts.push(f.split(":")[1].replace(/ /g, ""));
        }
      });
    }
    if (fonts.length <= 0 || sildeFonts.value.includes(fonts[0])) {
      isRe = true
    }
    const Fonts = [...new Set(sildeFonts.value.concat(fonts))]
    store.commit(MutationTypes.SET_SLIDES_FONTS, Fonts);
    if (isRe) return
    getFonts()
  };
  return {
    addSlidesFromClipboard,
    pasteTextClipboardData,
  }
}